export default "__VITE_ASSET__DG2umnsy__"